import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_viewer = _resolveComponent("file-viewer")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.title,
    size: "lg",
    ref: "modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_file_viewer, {
        class: "flex justify-center",
        file: _ctx.file
      }, null, 8, ["file"])
    ]),
    _: 1
  }, 8, ["title"]))
}